import React, { useState, useEffect, useRef } from 'react';
import { Container } from 'react-bootstrap';
import '../../../../assets/css/customer/publicCustomerCss/aboutus.css';
import img1 from '../../../../assets/images/img1.jpg';
import img2 from '../../../../assets/images/img2.jpg';
import img3 from '../../../../assets/images/img3.jpg';
import img4 from '../../../../assets/images/img4.jpg';
const AboutUs = () => {
  const [rotation, setRotation] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const stepRef = useRef(0);

  const sections = [
    {
      id: 1,
      title: "Travel",
      icon: "fas fa-plane",
      color: "#1a3a4d",
      backgroundImage:
        img1,
      description:
        "Pakistan sits between Central Asia, China, and the subcontinent — and its roads lead to places most travelers have never heard of. We plan routes that go beyond the obvious: jeep tracks into Shimshal, rest houses in Naltar, campsites above the Deosai plateau at 4,000 metres. The planning is ours. The memories are yours.",
    },
    {
      id: 2,
      title: "Landscape",
      icon: "fas fa-mountain",
      color: "#064e3b",
      backgroundImage:img2,
      description:
        "Three of the world's fourteen eight-thousanders rise inside Pakistan's borders. The Indus cuts through gorges older than the Himalayas. Fairy Meadows sits at the base of Nanga Parbat with an unobstructed view that stops most people in their tracks. We have been to these places enough times to know exactly where to stand and when.",
    },
    {
      id: 3,
      title: "Hospitality",
      icon: "fas fa-heart",
      color: "#78350f",
      backgroundImage:img3,    
        description:
        "In Hunza, a stranger arriving at a village in the evening will be fed before anyone asks why they are there. That instinct — to look after whoever is in front of you — runs through everything we do. Our team comes from the communities we work in. When you stay with us, you are not at a hotel. You are a guest.",
    },
    {
      id: 4,
      title: "Food",
      icon: "fas fa-utensils",
      color: "#881337",
      backgroundImage:img4,
      description:
        "Chapshuro fresh off a tawa in Karimabad. Harissa slow-cooked overnight in Gilgit. Trout pulled from the Kunhar River the same morning it reaches your plate. Pakistani food from the north is not well documented and rarely leaves the region. We make sure every trip includes meals that you will spend the rest of the journey thinking about.",
    },
  ];

  const WHEEL_DURATION = 2000;
  const INTERVAL = 6000;

  useEffect(() => {
    const interval = setInterval(() => {
      stepRef.current = (stepRef.current + 1) % sections.length;
      setRotation((prev) => prev - 90);
      setIsTransitioning(true);

      const timeout = setTimeout(() => {
        setActiveIndex(stepRef.current);
        setIsTransitioning(false);
      }, WHEEL_DURATION);

      return () => clearTimeout(timeout);
    }, INTERVAL);

    return () => clearInterval(interval);
  }, [sections.length]);

  return (
    <div className="cus-abt-about-section-wrapper">
      <div className="cus-abt-background-overlay"></div>
      {sections.map((section, index) => (
        <div
          key={section.id}
          className={`cus-abt-background-image ${index === activeIndex ? 'active' : ''}`}
          style={{ backgroundImage: `url(${section.backgroundImage})` }}
        />
      ))}

      <Container fluid className="cus-abt-inner-container">
        <div className="cus-abt-about-us-heading">
          <h1>About Us</h1>
          <p className="cus-abt-heading-subtitle">
            We are a travel company built by people who actually live here
          </p>
        </div>

        <div className="cus-abt-modern-wheel-section">
          {/* Wheel */}
          <div className="cus-abt-modern-wheel-container">
            <div className="cus-abt-wheel-visual-wrapper">
              <div
                className="cus-abt-wheel-circle"
                style={{
                  transform: `rotate(${rotation}deg)`,
                  transition: `transform ${WHEEL_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`,
                }}
              >
                {sections.map((item, index) => (
                  <div
                    key={item.id}
                    className={`cus-abt-wheel-segment cus-abt-segment-${index + 1}`}
                  >
                    <div
                      className="cus-abt-segment-inner"
                      style={{ background: item.color }}
                    >
                      <div
                        className="cus-abt-segment-content"
                        style={{
                          transform: `rotate(${-rotation - index * 90}deg)`,
                          transition: `transform ${WHEEL_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`,
                        }}
                      >
                        <i className={`${item.icon} cus-abt-segment-icon`}></i>
                        <div style={{ fontWeight: 'bold' }}>{item.title}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="cus-abt-wheel-center-hole"></div>
            </div>
          </div>

          <div className="cus-abt-modern-content-container">
            <div className={`cus-abt-content-wrapper ${isTransitioning ? 'cus-abt-fading' : 'cus-abt-visible'}`}>
              <h1 className="cus-abt-section-title">
                {sections[activeIndex].title}
              </h1>
              <p className="cus-abt-section-description">
                {sections[activeIndex].description}
              </p>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AboutUs;